<template>
  <div class="selection-bar" v-if="count > 0">
    <span class="selection-text">
      <strong>{{ count }}</strong>
      {{ count === 1 ? 'item selecionado' : 'itens selecionados' }}
      · <span class="tnum">{{ total | currency }}</span> glosados
      <template v-if="sameRound"> · mesma rodada <fa-icon :icon="['fal', 'check']"/></template>
    </span>
    <span class="selection-actions">
      <button class="btn btn-sm btn-link" @click="$emit('clear')">
        Limpar seleção <kbd>Esc</kbd>
      </button>
      <button class="btn btn-sm btn-gray"
              :class="tipClass(acceptDisabledReason)"
              :data-tooltip="acceptDisabledReason"
              :disabled="saving || !!acceptDisabledReason"
              @click="$emit('accept')">Aceitar glosa</button>
      <button class="btn btn-sm btn-primary btn-icon btn-icon-left"
              :class="[tipClass(appealDisabledReason), { loading: saving }]"
              :data-tooltip="appealDisabledReason"
              :disabled="saving || !!appealDisabledReason"
              @click="$emit('appeal')">
        <fa-icon :icon="['fal', overdue ? 'exclamation-triangle' : 'gavel']"/>Recursar
      </button>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    count: {
      type: Number,
      default: 0,
    },
    total: {
      type: Number,
      default: 0,
    },
    acceptDisabledReason: {
      type: String,
      default: null,
    },
    appealDisabledReason: {
      type: String,
      default: null,
    },
    sameRound: {
      type: Boolean,
      default: false,
    },
    overdue: {
      type: Boolean,
      default: false,
    },
    saving: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    document.addEventListener('keydown', this.onKeydown);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.onKeydown);
  },
  methods: {
    tipClass(reason) {
      return reason ? 'tooltip tooltip-left' : '';
    },
    onKeydown(event) {
      if (event.key !== 'Escape' || this.count === 0) return;
      if (document.querySelector('.modal.active')) return;
      this.$emit('clear');
    },
  },
};
</script>
